var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.months),function(month,index){return _c('div',{key:index,staticClass:"pb-8 px-3 -mx-3 overflow-hidden"},[_c('calendar-header',{attrs:{"month":month}}),_vm._v(" "),_c('calendar-grid',{attrs:{"month":month,"from":_vm.value,"to":null},on:{"click":_vm.handleDateClicked}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }